import React from "react";
import "./CarViewTextDetail.css";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

const CarViewTextDetail = props => (
  <div className="TextDetailDiv">
    <Grid
      container
      spacing={5}
      style={{ textAlign: "center", marginTop: "5px" }}
    >
      <Grid item xs={3}>
        <div className="TextDetailTitle">{props.titulo1}</div>
        <br />
        <div className="TextDetail">{props.texto1}</div>
      </Grid>
      <Grid item xs={1}>
        {" "}
        <br />
      </Grid>
      <Grid item xs={3}>
        <div className="TextDetailTitle">{props.titulo2}</div>
        <br />
        <div className="TextDetail">{props.texto2}</div>
      </Grid>
      <Grid item xs={1}>
        <br />
      </Grid>

      <Grid item xs={3}>
        <div className="TextDetailTitle">{props.titulo3}</div>
        <br />
        <div className="TextDetail">{props.texto3}</div>
      </Grid>
    </Grid>
  </div>
);

export default CarViewTextDetail;
